import React, { Component, Fragment } from 'react';
import PageRedirectRuleForm from './PageRedirectRuleForm';

export default class PageRedirectRule extends Component {
  state = {};

  getRoleOptions = () => {
    const { roles } = this.props;
    let options = [];
    options = roles.map((role, key) => ({ value: role.name, label: role.name }));
    return options;
  };

  getPageOptions = () => {
    const { pages } = this.props;
    const pageOptions =
      pages.length > 0 ? pages.map((item) => ({ value: '/' + item.slug, label: item.name })) : [];
    return pageOptions;
  };

  render() {
    const { createNewParamRow, params, collections } = this.props;
    return (
      <Fragment>
        <div className="table-responsive">
          <table className="table table-sm table-bordered table-condensed">
            <thead style={{ fontWeight: 'bold' }}>
              <tr>
                <td className="text-left">Role</td>
                <td className="text-left">Page</td>
              </tr>
            </thead>
            <tbody>
              {params.map((row) => {
                return (
                  <PageRedirectRuleForm
                    paramRow={row}
                    key={row.id}
                    createNewRow={createNewParamRow}
                    collections={collections}
                    roleOptions={this.getRoleOptions()}
                    pageOptions={this.getPageOptions()}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
}
